import moment from "moment"

export const isLate = (due: Date) => {
  return moment().isAfter(due)
}

export const isStarted = (start: Date) => {
  return moment().isAfter(start)
}

export const getEstimatedTimeDisplay = (
  seconds: number,
  t: (key: string, params: Record<string, any>) => string
) => {
  let minutes: number = 0
  let hours: number = 0
  if (seconds >= 60) {
    minutes = Math.floor(seconds / 60)
    seconds = seconds % 60
  }
  if (minutes >= 60) {
    hours = Math.floor(minutes / 60)
    minutes = minutes % 60
  }

  const display: string[] = []
  if (seconds > 0) {
    display.unshift(t(`{{ seconds }}s`, { seconds }))
  }
  if (minutes > 0) {
    display.unshift(t(`{{ minutes }}m`, { minutes }))
  }
  if (hours > 0) {
    display.unshift(
      t(`{{ hours }}h`, {
        hours
      })
    )
  }
  return display.filter((s) => s).join(" ")
}

type PathItemStats = {
  point_total: number
  progress: number
  time_to_complete: number
}

type GroupStats = {
  time_to_complete: number
  point_total: number
  step_count: number
  progress: number
}

export const getGroupStatsFromItemStats = (
  items: PathItemStats[]
): GroupStats => {
  return items.reduce(
    (result: GroupStats, m: PathItemStats) => {
      result.point_total += m.point_total
      result.progress = result.progress + m.progress
      result.time_to_complete += m.time_to_complete
      return result
    },
    {
      time_to_complete: 0,
      point_total: 0,
      progress: 0,
      step_count: items.length
    }
  )
}
